import { ShieldCheckIcon } from "@phosphor-icons/react";
import { lazy } from "react";
import { Outlet } from "react-router-dom";

const UsuarioPermissionCreate = lazy(() => import("../../modules/Cadastro/Usuario/permissoes/create").then((m) => ({ default: m.UsuarioPermissionCreate })));
const PermissaoFiliaisCreate = lazy(() => import("./PermissaoFiliais/PermissaoFiliaisCreate").then((m) => ({ default: m.PermissaoFiliaisCreate })));
const PermissaoFiliaisEdit = lazy(() => import("./PermissaoFiliais/PermissaoFiliaisEdit").then((m) => ({ default: m.PermissaoFiliaisEdit })));
const PermissaoFiliaisList = lazy(() => import("./PermissaoFiliais/PermissaoFiliaisList").then((m) => ({ default: m.PermissaoFiliaisList })));
const ClonePermittion = lazy(() => import("./PermissaoUsuarios/Clone").then((m) => ({ default: m.ClonePermittion })));
const PermissaoUsuariosList = lazy(() => import("./PermissaoUsuarios/List").then((m) => ({ default: m.PermissaoUsuariosList })));

const ModulePermissoes = {
  menuItem: {
    to: "/permissoes",
    id: 15,
    title: "Permissoes",
    icon: ShieldCheckIcon,
    childrens: [
      {
        to: "/permissoes/permissao-de-filiais",
        title: "Permissão de Filial",
        id: 77,
      },
      {
        to: "/permissoes/permissao-de-usuarios",
        title: "Permissão de Usuários",
        id: 78,
      },
    ],
  },
  routes: [
    {
      path: "permissoes/permissao-de-filiais",
      element: <Outlet />,
      children: [
        { path: "", element: <PermissaoFiliaisList /> },
        { path: ":id", element: <PermissaoFiliaisEdit /> },
        { path: "novo", element: <PermissaoFiliaisCreate /> },
      ],
    },
    {
      path: "permissoes/permissao-de-usuarios",

      element: <Outlet />,
      children: [
        {
          path: "",
          element: <PermissaoUsuariosList />,
          children: [
            {
              path: ":id/new",
              element: <UsuarioPermissionCreate />,
            },
            {
              path: ":id/clone",
              element: <ClonePermittion />,
            },
          ],
        },
      ],
    },
  ],
};

export default ModulePermissoes;
